import React from "react";
const images = require.context("../assets/images", false);

function Features() {
	return (
		<div className="features mt-80">
  <div className="container">
    <div className="heading center">
      <h2>Features</h2>
      <p>make your Trip a Memorable one!</p>
    </div>
    <div className="row">
      <div className="col-md-3 mb-5">
        <div className="features-card center">
          <div className="icon-box mb-4">
            <img src={images("./11.png")} alt="feature icon" />
          </div>
          <h4>Customized Itineraries</h4>
          <p>Customize your tour based on tour duration, preferred hotel or type of car</p>
        </div>
      </div>
      <div className="col-md-3 mb-5">
        <div className="features-card center">
          <div className="icon-box mb-4">
            <img src={images("./22.png")} alt="feature icon" />
          </div>
          <h4>Luxury 5 Star & Heritage Hotels</h4>
          <p>Choose from a wide range of luxury and heritage hotels.</p>
        </div>
      </div>
      <div className="col-md-3 mb-5">
        <div className="features-card center">
          <div className="icon-box mb-4">
            <img src={images("./33.png")} alt="feature icon" />
          </div>
          <h4>Highly Experienced Drivers</h4>
          <p>Our drivers are highly experienced and professional. They can go extra miles for your comfort.
          </p>
        </div>
      </div>
      <div className="col-md-3 mb-5">
        <div className="features-card center">
          <div className="icon-box mb-4">
            <img src={images("./44.png")} alt="feature icon" />
          </div>
          <h4>Professional Guides</h4>
          <p>Knowledgeable & experienced guides to show you the best of the city</p>
        </div>
      </div>
      <div className="col-md-3 mb-5">
        <div className="features-card center">
          <div className="icon-box mb-4">
            <img src={images("./55.png")} alt="feature icon" />
          </div>
          <h4>Authentic Experiences</h4>
          <p>Traditional Himalayan Wedding, Diwali with Family or Shopping a Saree. You just Name it!</p>
        </div>
      </div>
      <div className="col-md-3 mb-5">
        <div className="features-card center">
          <div className="icon-box mb-4">
            <img src={images("./66.png")} alt="feature icon" />
          </div>
          <h4>Luxury Amenities during your Tour</h4>
          <p>Mineral Water Bottle, Free WiFi, Umbrella etc. for a smooth and luxury ride</p>
        </div>
      </div>
      <div className="col-md-3 mb-5">
        <div className="features-card center">
          <div className="icon-box mb-4">
            <img src={images("./77.png")} alt="feature icon" />
          </div>
          <h4>Dedicated Travel Expert</h4>
          <p>Dedicated travel expert from the planning phase till your departure for a smooth experience</p>
        </div>
      </div>
      <div className="col-md-3 mb-5">
        <div className="features-card center">
          <div className="icon-box mb-4">
            <img src={images("./88.png")} alt="feature icon" />
          </div>
          <h4>24 X 7 Personal Assistance</h4>
          <p>Round the clock customer care for any assistance during your tour</p>
        </div>
      </div>
    </div>
  </div>
</div>
	);
}

export default Features;
